(function($, undefined) {

	'use strict';

	var initLogosSlider = function() {
		$('.quotes-outer-ctn.ver1 .quotes-inner-ctn').each(function() {
			var t = $(this);

			t.slick({
				dots: true,
				arrows: true,
				prevArrow: t.find('.arrow-btn.prev'),
				nextArrow: t.find('.arrow-btn.next'),
				slide: '.one-quote',
				slidesToShow: 1,
				fade: true,
				responsive: [
					{
						breakpoint: 768,
						settings: {
							fade: false,
						}
					},
				]
			}).fadeIn();
		});

		$('.quotes-outer-ctn.ver2 .quotes-inner-ctn').each(function() {
			var t = $(this);
			if (t.closest('.side-nav-content-ctn').length) {
				t.slick({
					dots: true,
					arrows: true,
					prevArrow: t.find('.arrow-btn.prev'),
					nextArrow: t.find('.arrow-btn.next'),
					slide: '.one-quote',
					slidesToShow: 2,
					slidesToScroll: 2,
					responsive: [
						{
							breakpoint: 1280,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1,
							}
						},
					]
				}).fadeIn();
			} else {
				t.slick({
					dots: true,
					arrows: true,
					prevArrow: t.find('.arrow-btn.prev'),
					nextArrow: t.find('.arrow-btn.next'),
					slide: '.one-quote',
					slidesToShow: 3,
					slidesToScroll: 3,
					responsive: [
						{
							breakpoint: 1150,
							settings: {
								slidesToShow: 2,
								slidesToScroll: 2,
							}
						},
						{
							breakpoint: 768,
							settings: {
								// rtl: true,
								slidesToShow: 1,
								slidesToScroll: 1,
							}
						},
					]
				}).fadeIn();
			}
		});
	};

	var init = function() {
		initLogosSlider();
	};
	
	$(window).ready(function () {
		init();
	});

})(jQuery);

